{
  "frame103397": {
    "name": "frame103397",
    "format": "svg",
    "scale": 1,
    "id": "3710:15122",
    "url": "../figma/images/frame103397.svg",
    "variants": {
      "VariantDesktop": {
        "id": "3710:15122",
        "width": 155,
        "height": 24
      }
    }
  },
  "iconSearch24": {
    "name": "iconSearch24",
    "format": "svg",
    "scale": 1,
    "id": "3710:15139",
    "url": "../figma/images/iconSearch24.svg",
    "variants": {
      "VariantDesktop": {
        "id": "3710:15139",
        "width": 16,
        "height": 16
      }
    }
  },
  "iconmail": {
    "name": "iconmail",
    "format": "svg",
    "scale": 1,
    "id": "3124:12655",
    "url": "../figma/images/iconmail.svg",
    "variants": {
      "VariantDesktop": {
        "id": "3124:12655",
        "width": 16,
        "height": 16
      }
    }
  },
  "iconpercent": {
    "name": "iconpercent",
    "format": "svg",
    "scale": 1,
    "id": "3124:12651",
    "url": "../figma/images/iconpercent.svg",
    "variants": {
      "VariantDesktop": {
        "id": "3124:12651",
        "width": 16,
        "height": 16
      }
    }
  },
  "iconbell": {
    "name": "iconbell",
    "format": "svg",
    "scale": 1,
    "id": "3124:12646",
    "url": "../figma/images/iconbell.svg",
    "variants": {
      "VariantDesktop": {
        "id": "3124:12646",
        "width": 16,
        "height": 16
      }
    }
  },
  "emptyStateImage": {
    "name": "emptyStateImage",
    "format": "png",
    "scale": 2,
    "id": "3106:12525",
    "url": "../figma/images/emptyStateImage.png",
    "variants": {
      "VariantDesktop": {
        "id": "3106:12525",
        "width": 275,
        "height": 249
      }
    }
  },
  "iconReminder": {
    "name": "iconReminder",
    "format": "svg",
    "scale": 1,
    "id": "3003:11577",
    "url": "../figma/images/iconReminder.svg",
    "variants": {
      "VariantDesktop": {
        "id": "3003:11577",
        "width": 16,
        "height": 16
      }
    }
  },
  "iconCollectDebt": {
    "name": "iconCollectDebt",
    "format": "svg",
    "scale": 1,
    "id": "3003:11579",
    "url": "../figma/images/iconCollectDebt.svg",
    "variants": {
      "VariantDesktop": {
        "id": "3003:11579",
        "width": 16,
        "height": 16
      }
    }
  },
  "iconSnooze": {
    "name": "iconSnooze",
    "format": "svg",
    "scale": 1,
    "id": "3003:11582",
    "url": "../figma/images/iconSnooze.svg",
    "variants": {
      "VariantDesktop": {
        "id": "3003:11582",
        "width": 16,
        "height": 16
      }
    }
  },
  "iconstar": {
    "name": "iconstar",
    "format": "svg",
    "scale": 1,
    "id": "3003:13811",
    "url": "../figma/images/iconstar.svg",
    "variants": {
      "VariantDesktop": {
        "id": "3003:13811",
        "width": 20,
        "height": 20
      }
    }
  },
  "iconBook": {
    "name": "iconBook",
    "format": "svg",
    "scale": 1,
    "id": "3003:13789",
    "url": "../figma/images/iconBook.svg",
    "variants": {
      "VariantDesktop": {
        "id": "3003:13789",
        "width": 16,
        "height": 16
      }
    }
  },
  "hoverState": {
    "name": "hoverState",
    "format": "svg",
    "scale": 1,
    "id": "3003:12542",
    "url": "../figma/images/hoverState.svg",
    "variants": {
      "VariantDesktop": {
        "id": "3003:12542",
        "width": 7,
        "height": 13
      }
    }
  },
  "iconPageLeft": {
    "name": "iconPageLeft",
    "format": "svg",
    "scale": 1,
    "id": "3710:15627",
    "url": "../figma/images/iconPageLeft.svg",
    "variants": {
      "VariantDesktop": {
        "id": "3710:15627",
        "width": 16,
        "height": 18
      }
    }
  },
  "iconPageRight": {
    "name": "iconPageRight",
    "format": "svg",
    "scale": 1,
    "id": "3710:15630",
    "url": "../figma/images/iconPageRight.svg",
    "variants": {
      "VariantDesktop": {
        "id": "3710:15630",
        "width": 16,
        "height": 18
      }
    }
  },
  "iconStarUnstarred": {
    "name": "iconStarUnstarred",
    "format": "svg",
    "scale": 1,
    "id": "3003:14291",
    "url": "../figma/images/iconStarUnstarred.svg",
    "variants": {
      "VariantDesktop": {
        "id": "3003:14291",
        "width": 28,
        "height": 28
      }
    }
  },
  "iconStarStarred": {
    "name": "iconStarStarred",
    "format": "svg",
    "scale": 1,
    "id": "3003:14292",
    "url": "../figma/images/iconStarStarred.svg",
    "variants": {
      "VariantDesktop": {
        "id": "3003:14292",
        "width": 28,
        "height": 28
      }
    }
  },
  "checkboxUnchecked": {
    "name": "checkboxUnchecked",
    "format": "svg",
    "scale": 1,
    "id": "3003:14297",
    "url": "../figma/images/checkboxUnchecked.svg",
    "variants": {
      "VariantDesktop": {
        "id": "3003:14297",
        "width": 18,
        "height": 18
      }
    }
  },
  "iconCheck": {
    "name": "iconCheck",
    "format": "svg",
    "scale": 1,
    "id": "3710:15544",
    "url": "../figma/images/iconCheck.svg",
    "variants": {
      "VariantDesktop": {
        "id": "3710:15544",
        "width": 24,
        "height": 24
      }
    }
  },
  "checkBoxChecked": {
    "name": "checkBoxChecked",
    "format": "svg",
    "scale": 1,
    "id": "3003:14298",
    "url": "../figma/images/checkBoxChecked.svg",
    "variants": {
      "VariantDesktop": {
        "id": "3003:14298",
        "width": 18,
        "height": 18
      }
    }
  },
  "inboxCustomerSuccessAll": {
    "name": "inboxCustomerSuccessAll",
    "format": "png",
    "scale": 1,
    "id": "3104:12282",
    "url": "../figma/images/inboxCustomerSuccessAll.png",
    "variants": {
      "VariantDesktop": {
        "id": "3104:12282",
        "width": 1440,
        "height": 1059
      }
    }
  },
  "buttonIconAddCard": {
    "name": "buttonIconAddCard",
    "format": "svg",
    "scale": 1,
    "id": "2022:5959",
    "url": "../figma/images/buttonIconAddCard.svg",
    "variants": {
      "VariantDesktop": {
        "id": "2022:5959",
        "width": 48,
        "height": 48
      }
    }
  },
  "iconButtonEmail": {
    "name": "iconButtonEmail",
    "format": "svg",
    "scale": 1,
    "id": "2598:5066",
    "url": "../figma/images/iconButtonEmail.svg",
    "variants": {
      "VariantDesktop": {
        "id": "2598:5066",
        "width": 48,
        "height": 48
      }
    }
  },
  "iconButtonDelete": {
    "name": "iconButtonDelete",
    "format": "svg",
    "scale": 1,
    "id": "2981:12038",
    "url": "../figma/images/iconButtonDelete.svg",
    "variants": {
      "VariantDesktop": {
        "id": "2981:12038",
        "width": 48,
        "height": 48
      }
    }
  },
  "iconButtonrefreshAddress": {
    "name": "iconButtonrefreshAddress",
    "format": "svg",
    "scale": 1,
    "id": "3303:14352",
    "url": "../figma/images/iconButtonrefreshAddress.svg",
    "variants": {
      "VariantDesktop": {
        "id": "3303:14352",
        "width": 48,
        "height": 48
      }
    }
  },
  "iconButtonrefreshAddressHover": {
    "name": "iconButtonrefreshAddressHover",
    "format": "svg",
    "scale": 1,
    "id": "3303:14368",
    "url": "../figma/images/iconButtonrefreshAddressHover.svg",
    "variants": {
      "VariantDesktop": {
        "id": "3303:14368",
        "width": 48,
        "height": 48
      }
    }
  },
  "frame10637": {
    "name": "frame10637",
    "format": "png",
    "scale": 1,
    "id": "1786:4427",
    "url": "../figma/images/frame10637.png",
    "variants": {
      "VariantDesktop": {
        "id": "1786:4427",
        "width": 72,
        "height": 48
      }
    }
  },
  "frame10590": {
    "name": "frame10590",
    "format": "png",
    "scale": 1,
    "id": "1785:4467",
    "url": "../figma/images/frame10590.png",
    "variants": {
      "VariantDesktop": {
        "id": "1785:4467",
        "width": 300,
        "height": 48
      }
    }
  },
  "hidden": {
    "name": "hidden",
    "format": "svg",
    "scale": 1,
    "id": "3303:14300",
    "url": "../figma/images/hidden.svg",
    "variants": {
      "VariantDesktop": {
        "id": "3303:14300",
        "width": 48,
        "height": 48
      }
    }
  },
  "frame10632": {
    "name": "frame10632",
    "format": "svg",
    "scale": 1,
    "id": "3710:15543",
    "url": "../figma/images/frame10632.svg",
    "variants": {
      "VariantDesktop": {
        "id": "3710:15543",
        "width": 56,
        "height": 48
      }
    }
  },
  "iconSearch": {
    "name": "iconSearch",
    "format": "png",
    "scale": 1,
    "id": "3710:15554",
    "url": "../figma/images/iconSearch.png",
    "variants": {
      "VariantDesktop": {
        "id": "3710:15554",
        "width": 24,
        "height": 24
      }
    }
  },
  "arrow": {
    "name": "arrow",
    "format": "svg",
    "scale": 1,
    "id": "3710:15561",
    "url": "../figma/images/arrow.svg",
    "variants": {
      "VariantDesktop": {
        "id": "3710:15561",
        "width": 10,
        "height": 10
      }
    }
  },
  "buttonIconChangeStatus": {
    "name": "buttonIconChangeStatus",
    "format": "svg",
    "scale": 1,
    "id": "2333:5987",
    "url": "../figma/images/buttonIconChangeStatus.svg",
    "variants": {
      "VariantDesktop": {
        "id": "2333:5987",
        "width": 48,
        "height": 48
      }
    }
  },
  "iconExport24LinkGreen": {
    "name": "iconExport24LinkGreen",
    "format": "svg",
    "scale": 1,
    "id": "1219:3762",
    "url": "../figma/images/iconExport24LinkGreen.svg",
    "variants": {
      "VariantDesktop": {
        "id": "1219:3762",
        "width": 16,
        "height": 16
      }
    }
  },
  "iconCalendar24": {
    "name": "iconCalendar24",
    "format": "svg",
    "scale": 1,
    "id": "1012:3216",
    "url": "../figma/images/iconCalendar24.svg",
    "variants": {
      "VariantDesktop": {
        "id": "1012:3216",
        "width": 24,
        "height": 24
      }
    }
  },
  "iconTrash": {
    "name": "iconTrash",
    "format": "svg",
    "scale": 1,
    "id": "2629:6719",
    "url": "../figma/images/iconTrash.svg",
    "variants": {
      "VariantDesktop": {
        "id": "2629:6719",
        "width": 24,
        "height": 24
      }
    }
  },
  "plus": {
    "name": "plus",
    "format": "svg",
    "scale": 1,
    "id": "I2629:6725;898:61",
    "url": "../figma/images/plus.svg",
    "variants": {
      "VariantDesktop": {
        "id": "I2629:6725;898:61",
        "width": 24,
        "height": 24
      }
    }
  },
  "vector": {
    "name": "vector",
    "format": "svg",
    "scale": 1,
    "id": "I2750:6806;3541:1",
    "url": "../figma/images/vector.svg",
    "variants": {
      "VariantDesktop": {
        "id": "I2750:6806;3541:1",
        "width": 16,
        "height": 16
      }
    }
  },
  "roundXCircle": {
    "name": "roundXCircle",
    "format": "svg",
    "scale": 1,
    "id": "2750:6832",
    "url": "../figma/images/roundXCircle.svg",
    "variants": {
      "VariantDesktop": {
        "id": "2750:6832",
        "width": 14,
        "height": 14
      }
    }
  },
  "iconDownload24": {
    "name": "iconDownload24",
    "format": "svg",
    "scale": 1,
    "id": "I2750:6821;1478:319",
    "url": "../figma/images/iconDownload24.svg",
    "variants": {
      "VariantDesktop": {
        "id": "I2750:6821;1478:319",
        "width": 24,
        "height": 24
      }
    }
  },
  "buttonIconRegisterExternalPayment": {
    "name": "buttonIconRegisterExternalPayment",
    "format": "svg",
    "scale": 1,
    "id": "3147:12942",
    "url": "../figma/images/buttonIconRegisterExternalPayment.svg",
    "variants": {
      "VariantDesktop": {
        "id": "3147:12942",
        "width": 48,
        "height": 48
      }
    }
  },
  "buttonIconRegisterInvoicePayment": {
    "name": "buttonIconRegisterInvoicePayment",
    "format": "svg",
    "scale": 1,
    "id": "3147:12946",
    "url": "../figma/images/buttonIconRegisterInvoicePayment.svg",
    "variants": {
      "VariantDesktop": {
        "id": "3147:12946",
        "width": 48,
        "height": 48
      }
    }
  },
  "buttonIconCreateInvoice": {
    "name": "buttonIconCreateInvoice",
    "format": "svg",
    "scale": 1,
    "id": "3147:13671",
    "url": "../figma/images/buttonIconCreateInvoice.svg",
    "variants": {
      "VariantDesktop": {
        "id": "3147:13671",
        "width": 48,
        "height": 48
      }
    }
  },
  "iconRemoveOverride": {
    "name": "iconRemoveOverride",
    "format": "svg",
    "scale": 1,
    "id": "3643:14944",
    "url": "../figma/images/iconRemoveOverride.svg",
    "variants": {
      "VariantDesktop": {
        "id": "3643:14944",
        "width": 15,
        "height": 15
      }
    }
  },
  "iconAlertInfoYellow": {
    "name": "iconAlertInfoYellow",
    "format": "svg",
    "scale": 1,
    "id": "3643:14943",
    "url": "../figma/images/iconAlertInfoYellow.svg",
    "variants": {
      "VariantDesktop": {
        "id": "3643:14943",
        "width": 16,
        "height": 16
      }
    }
  },
  "logoBo": {
    "name": "logoBo",
    "format": "svg",
    "scale": 1,
    "id": "2452:9503",
    "url": "../figma/images/logoBo.svg",
    "variants": {
      "VariantDesktop": {
        "id": "2452:9503",
        "width": 111,
        "height": 24
      }
    }
  },
  "iconFileAddition24": {
    "name": "iconFileAddition24",
    "format": "svg",
    "scale": 1,
    "id": "24:799",
    "url": "../figma/images/iconFileAddition24.svg",
    "variants": {
      "VariantDesktop": {
        "id": "24:799",
        "width": 24,
        "height": 24
      }
    }
  },
  "image2": {
    "name": "image2",
    "format": "png",
    "scale": 1,
    "id": "24:1050",
    "url": "../figma/images/image2.png",
    "variants": {
      "VariantDesktop": {
        "id": "24:1050",
        "width": 1153,
        "height": 241
      }
    }
  },
  "image3": {
    "name": "image3",
    "format": "png",
    "scale": 1,
    "id": "24:1051",
    "url": "../figma/images/image3.png",
    "variants": {
      "VariantDesktop": {
        "id": "24:1051",
        "width": 1153,
        "height": 241
      }
    }
  },
  "pdfInvoice": {
    "name": "pdfInvoice",
    "format": "svg",
    "scale": 1,
    "id": "24:1881",
    "url": "../figma/images/pdfInvoice.svg",
    "variants": {
      "VariantDesktop": {
        "id": "24:1881",
        "width": 23.9990234375,
        "height": 24
      }
    }
  },
  "book": {
    "name": "book",
    "format": "svg",
    "scale": 1,
    "id": "24:1967",
    "url": "../figma/images/book.svg",
    "variants": {
      "VariantDesktop": {
        "id": "24:1967",
        "width": 17.1904296875,
        "height": 20
      }
    }
  },
  "cancel": {
    "name": "cancel",
    "format": "svg",
    "scale": 1,
    "id": "24:1968",
    "url": "../figma/images/cancel.svg",
    "variants": {
      "VariantDesktop": {
        "id": "24:1968",
        "width": 24,
        "height": 24
      }
    }
  },
  "credit": {
    "name": "credit",
    "format": "svg",
    "scale": 1,
    "id": "24:1971",
    "url": "../figma/images/credit.svg",
    "variants": {
      "VariantDesktop": {
        "id": "24:1971",
        "width": 23.9990234375,
        "height": 24
      }
    }
  },
  "remind": {
    "name": "remind",
    "format": "svg",
    "scale": 1,
    "id": "24:1975",
    "url": "../figma/images/remind.svg",
    "variants": {
      "VariantDesktop": {
        "id": "24:1975",
        "width": 24,
        "height": 24
      }
    }
  },
  "debtCollection": {
    "name": "debtCollection",
    "format": "svg",
    "scale": 1,
    "id": "24:1978",
    "url": "../figma/images/debtCollection.svg",
    "variants": {
      "VariantDesktop": {
        "id": "24:1978",
        "width": 24,
        "height": 24
      }
    }
  },
  "accountingIcon": {
    "name": "accountingIcon",
    "format": "svg",
    "scale": 1,
    "id": "24:2128",
    "url": "../figma/images/accountingIcon.svg",
    "variants": {
      "VariantDesktop": {
        "id": "24:2128",
        "width": 23.9990234375,
        "height": 24
      }
    }
  },
  "bookIcon": {
    "name": "bookIcon",
    "format": "svg",
    "scale": 1,
    "id": "832:1881",
    "url": "../figma/images/bookIcon.svg",
    "variants": {
      "VariantDesktop": {
        "id": "832:1881",
        "width": 24,
        "height": 24
      }
    }
  },
  "cancelIcon": {
    "name": "cancelIcon",
    "format": "svg",
    "scale": 1,
    "id": "24:2307",
    "url": "../figma/images/cancelIcon.svg",
    "variants": {
      "VariantDesktop": {
        "id": "24:2307",
        "width": 24,
        "height": 24
      }
    }
  },
  "creditIcon": {
    "name": "creditIcon",
    "format": "svg",
    "scale": 1,
    "id": "24:2310",
    "url": "../figma/images/creditIcon.svg",
    "variants": {
      "VariantDesktop": {
        "id": "24:2310",
        "width": 23.9990234375,
        "height": 24
      }
    }
  },
  "remindIcon": {
    "name": "remindIcon",
    "format": "svg",
    "scale": 1,
    "id": "24:2314",
    "url": "../figma/images/remindIcon.svg",
    "variants": {
      "VariantDesktop": {
        "id": "24:2314",
        "width": 24,
        "height": 24
      }
    }
  },
  "debtCollectionIcon": {
    "name": "debtCollectionIcon",
    "format": "svg",
    "scale": 1,
    "id": "24:2317",
    "url": "../figma/images/debtCollectionIcon.svg",
    "variants": {
      "VariantDesktop": {
        "id": "24:2317",
        "width": 24,
        "height": 24
      }
    }
  },
  "activateCardIcon": {
    "name": "activateCardIcon",
    "format": "svg",
    "scale": 1,
    "id": "24:2681",
    "url": "../figma/images/activateCardIcon.svg",
    "variants": {
      "VariantDesktop": {
        "id": "24:2681",
        "width": 24,
        "height": 24
      }
    }
  },
  "editIconDeletePerson": {
    "name": "editIconDeletePerson",
    "format": "svg",
    "scale": 1,
    "id": "24:2997",
    "url": "../figma/images/editIconDeletePerson.svg",
    "variants": {
      "VariantDesktop": {
        "id": "24:2997",
        "width": 24,
        "height": 24
      }
    }
  },
  "mailIconDeletePerson": {
    "name": "mailIconDeletePerson",
    "format": "svg",
    "scale": 1,
    "id": "24:3000",
    "url": "../figma/images/mailIconDeletePerson.svg",
    "variants": {
      "VariantDesktop": {
        "id": "24:3000",
        "width": 24,
        "height": 24
      }
    }
  },
  "smsIconDeletePerson": {
    "name": "smsIconDeletePerson",
    "format": "svg",
    "scale": 1,
    "id": "24:3003",
    "url": "../figma/images/smsIconDeletePerson.svg",
    "variants": {
      "VariantDesktop": {
        "id": "24:3003",
        "width": 24,
        "height": 24
      }
    }
  },
  "removeIconDeletePerson": {
    "name": "removeIconDeletePerson",
    "format": "svg",
    "scale": 1,
    "id": "24:3005",
    "url": "../figma/images/removeIconDeletePerson.svg",
    "variants": {
      "VariantDesktop": {
        "id": "24:3005",
        "width": 24,
        "height": 24
      }
    }
  },
  "inviteMailIconDeletePerson": {
    "name": "inviteMailIconDeletePerson",
    "format": "svg",
    "scale": 1,
    "id": "24:3006",
    "url": "../figma/images/inviteMailIconDeletePerson.svg",
    "variants": {
      "VariantDesktop": {
        "id": "24:3006",
        "width": 24,
        "height": 24
      }
    }
  },
  "logInAsUserIconDeletePerson": {
    "name": "logInAsUserIconDeletePerson",
    "format": "svg",
    "scale": 1,
    "id": "24:3011",
    "url": "../figma/images/logInAsUserIconDeletePerson.svg",
    "variants": {
      "VariantDesktop": {
        "id": "24:3011",
        "width": 24,
        "height": 24
      }
    }
  },
  "iconInfoError": {
    "name": "iconInfoError",
    "format": "png",
    "scale": 1,
    "id": "118:736",
    "url": "../figma/images/iconInfoError.png",
    "variants": {
      "VariantDesktop": {
        "id": "118:736",
        "width": 20,
        "height": 20
      }
    }
  },
  "deleteCustomerIcon": {
    "name": "deleteCustomerIcon",
    "format": "svg",
    "scale": 1,
    "id": "452:4855",
    "url": "../figma/images/deleteCustomerIcon.svg",
    "variants": {
      "VariantDesktop": {
        "id": "452:4855",
        "width": 24,
        "height": 24
      }
    }
  },
  "refreshIcon24": {
    "name": "refreshIcon24",
    "format": "svg",
    "scale": 1,
    "id": "1012:3171",
    "url": "../figma/images/refreshIcon24.svg",
    "variants": {
      "VariantDesktop": {
        "id": "1012:3171",
        "width": 23.9990234375,
        "height": 24
      }
    }
  },
  "paginationPageNextIcon": {
    "name": "paginationPageNextIcon",
    "format": "svg",
    "scale": 1,
    "id": "1318:5158",
    "url": "../figma/images/paginationPageNextIcon.svg",
    "variants": {
      "VariantDesktop": {
        "id": "1318:5158",
        "width": 24,
        "height": 24
      }
    }
  },
  "customerInvoicesTopupReference": {
    "name": "customerInvoicesTopupReference",
    "format": "png",
    "scale": 1,
    "id": "1404:65015",
    "url": "../figma/images/customerInvoicesTopupReference.png",
    "variants": {
      "VariantDesktop": {
        "id": "1404:65015",
        "width": 136,
        "height": 20
      }
    }
  },
  "figma24": {
    "name": "figma24",
    "format": "svg",
    "scale": 1,
    "id": "0:67",
    "url": "../figma/images/figma24.svg",
    "variants": {
      "VariantMobile": {
        "id": "0:209",
        "width": 24,
        "height": 16.5
      },
      "VariantDesktop": {
        "id": "0:67",
        "width": 32,
        "height": 22
      }
    }
  },
  "finland24": {
    "name": "finland24",
    "format": "svg",
    "scale": 1,
    "id": "0:70",
    "url": "../figma/images/finland24.svg",
    "variants": {
      "VariantMobile": {
        "id": "0:212",
        "width": 24,
        "height": 24
      },
      "VariantDesktop": {
        "id": "0:70",
        "width": 32,
        "height": 32
      }
    }
  },
  "warningCircle": {
    "name": "warningCircle",
    "format": "svg",
    "scale": 1,
    "id": "0:77",
    "url": "../figma/images/warningCircle.svg",
    "variants": {
      "VariantDesktop": {
        "id": "0:77",
        "width": 24,
        "height": 24
      }
    }
  },
  "successCircle": {
    "name": "successCircle",
    "format": "svg",
    "scale": 1,
    "id": "0:100",
    "url": "../figma/images/successCircle.svg",
    "variants": {
      "VariantDesktop": {
        "id": "0:100",
        "width": 24,
        "height": 24
      }
    }
  },
  "errorCircle": {
    "name": "errorCircle",
    "format": "svg",
    "scale": 1,
    "id": "0:147",
    "url": "../figma/images/errorCircle.svg",
    "variants": {
      "VariantDesktop": {
        "id": "0:147",
        "width": 24,
        "height": 24
      }
    }
  },
  "filePdf": {
    "name": "filePdf",
    "format": "svg",
    "scale": 1,
    "id": "0:164",
    "url": "../figma/images/filePdf.svg",
    "variants": {
      "VariantMobile": {
        "id": "0:238",
        "width": 48,
        "height": 48
      },
      "VariantDesktop": {
        "id": "0:164",
        "width": 48,
        "height": 48
      }
    }
  },
  "filePdfHover": {
    "name": "filePdfHover",
    "format": "svg",
    "scale": 1,
    "id": "0:168",
    "url": "../figma/images/filePdfHover.svg",
    "variants": {
      "VariantMobile": {
        "id": "0:242",
        "width": 48,
        "height": 48
      },
      "VariantDesktop": {
        "id": "0:168",
        "width": 48,
        "height": 48
      }
    }
  },
  "fileJpg": {
    "name": "fileJpg",
    "format": "svg",
    "scale": 1,
    "id": "0:172",
    "url": "../figma/images/fileJpg.svg",
    "variants": {
      "VariantMobile": {
        "id": "0:246",
        "width": 48,
        "height": 48
      },
      "VariantDesktop": {
        "id": "0:172",
        "width": 48,
        "height": 48
      }
    }
  },
  "fileJpgHover": {
    "name": "fileJpgHover",
    "format": "svg",
    "scale": 1,
    "id": "0:176",
    "url": "../figma/images/fileJpgHover.svg",
    "variants": {
      "VariantMobile": {
        "id": "0:250",
        "width": 48,
        "height": 48
      },
      "VariantDesktop": {
        "id": "0:176",
        "width": 48,
        "height": 48
      }
    }
  },
  "filePng": {
    "name": "filePng",
    "format": "svg",
    "scale": 1,
    "id": "0:180",
    "url": "../figma/images/filePng.svg",
    "variants": {
      "VariantMobile": {
        "id": "0:254",
        "width": 48,
        "height": 48
      },
      "VariantDesktop": {
        "id": "0:180",
        "width": 48,
        "height": 48
      }
    }
  },
  "filePngHover": {
    "name": "filePngHover",
    "format": "svg",
    "scale": 1,
    "id": "0:184",
    "url": "../figma/images/filePngHover.svg",
    "variants": {
      "VariantMobile": {
        "id": "0:258",
        "width": 48,
        "height": 48
      },
      "VariantDesktop": {
        "id": "0:184",
        "width": 48,
        "height": 48
      }
    }
  },
  "fileGeneral": {
    "name": "fileGeneral",
    "format": "svg",
    "scale": 1,
    "id": "0:188",
    "url": "../figma/images/fileGeneral.svg",
    "variants": {
      "VariantMobile": {
        "id": "0:262",
        "width": 48,
        "height": 48
      },
      "VariantDesktop": {
        "id": "0:188",
        "width": 48,
        "height": 48
      }
    }
  },
  "fileGeneralHover": {
    "name": "fileGeneralHover",
    "format": "svg",
    "scale": 1,
    "id": "0:194",
    "url": "../figma/images/fileGeneralHover.svg",
    "variants": {
      "VariantMobile": {
        "id": "0:268",
        "width": 48,
        "height": 48
      },
      "VariantDesktop": {
        "id": "0:194",
        "width": 48,
        "height": 48
      }
    }
  },
  "smallScreenInfoImage": {
    "name": "smallScreenInfoImage",
    "format": "svg",
    "scale": 1,
    "id": "503:147",
    "url": "../figma/images/smallScreenInfoImage.svg",
    "variants": {
      "VariantMobile": {
        "id": "503:154",
        "width": 64,
        "height": 64
      },
      "VariantDesktop": {
        "id": "503:147",
        "width": 64,
        "height": 64
      }
    }
  }
}
